<script type="text/ecmascript-6">
import Helper from './helper'
import { h } from 'vue'

export default {
  name: 'VCol',
  props: {
    has: {
      type: [Number, String, Object],
      default: null
    },
    off: {
      type: [Number, String, Object],
      default: null
    },
    element: {
      type: String,
      default: 'div'
    }
  },
  methods: {
    ...Helper
  },
  render: function () {
    const options = {
      class: this.getClass([
        'col',
        this.rwd('has', 'is'),
        this.rwd('off', 'off')
      ])
    }
    return h(
      this.element, options,
      this.$slots?.default?.()
    )
  }
}
</script>
